import React from 'react';
import { Box, Link, Text } from 'braid-design-system';
import { Canva } from './CanvaSVG';

import * as styles from './CanvaButton.css';
import { events, link } from 'src/modules/analyticsTracker';

import { useTranslations } from '@vocab/react';
import translations from './.vocab';

export const CanvaButton = () => {
  const onCanvaButtonClick = () => {
    link(events.CANVA_BUTTON_INTERACTED);
  };

  const { t } = useTranslations(translations);

  return (
    <Link
      href="https://www.canva.com/templates/?query=SEEK-Cover-Images&utm_medium=partnerships&utm_source=seek_branding_email&utm_campaign=global_all_integrations_acq_conversion_button_poc_seek_banner_campaign"
      target="_blank"
      onClick={onCanvaButtonClick}
    >
      <Box className={styles.canvaButton}>
        <Box className={styles.canvaIconBackground} />
        <Box className={styles.canvaIcon}>
          <Canva />
        </Box>
        <Text size="small">{t('Design on Canva')}</Text>
      </Box>
    </Link>
  );
};
